'use client';

import { Auth0Provider } from '@auth0/nextjs-auth0/client';
import { SWRConfig } from 'swr';

export function AuthProvider({ children }: { children: React.ReactNode }) {
  return (
    <Auth0Provider>
      <SWRConfig
        value={{
          dedupingInterval: 60_000,
          revalidateOnFocus: false,
          revalidateOnReconnect: false,
          revalidateIfStale: false,
          shouldRetryOnError: false,
          errorRetryCount: 0,
        }}
      >
        {children}
      </SWRConfig>
    </Auth0Provider>
  );
}
